import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SectionHeader from '../../../common/SectionHeader'
import Table from '../../../common/Table'
import SearchField from '../../../common/SearchField'
import LoadingBlock from '../../../common/LoadingBlock'
import './style.sass'
import { getPendingReviews } from '../../../../redux/actions/release'
import { useHistory } from 'react-router'
import ApplicationStatus from '../../../../constants/ApplicationStatus'
import ReviewListErrorState from './components/ReviewListErrorState'
import ReviewListEmptyState from './components/ReviewListEmptyState'

const headers = [
  'Name',
  'Version',
  'Category',
  'Approval type'
]

const PendingReviews = () => {
  // ==== Local state ====
  const [filterText, setFilterText] = useState('')

  const history = useHistory()
  const dispatch = useDispatch()

  const reviewList = useSelector(({ release }) => release.reviewList)
  const fetchingReviewList = useSelector(({ release }) => release.fetchingReviewList)
  const errorFetchingReviewList = useSelector(({ release }) => release.errorFetchingReviewList)

  // ==== Get data ====
  useEffect(() => {
    dispatch(getPendingReviews())
  }, [])

  // ==== Methods ====
  const getStatusCompoent = (status) => {
    switch (status) {
      case ApplicationStatus.PUBLISHED:
      case ApplicationStatus.UPDATED:
        return <div className="app-state app-state-update"><span> App Update</span></div>
      default:
        return <div className="app-state app-state-new"><span> New App</span></div>
    }
  }

  const generateTableRows = () => {
    const filteredApps = getFilteredApps()
    return filteredApps.map(i => ({
      orignal: i,
      data: [
        i.applicationData?.name,
        `v${i.version?.toFixed(1).toString()}`,
        i.applicationData?.applicationCategory?.name,
        getStatusCompoent(i.application?.status)
      ]
    }))
  }

  const getFilteredApps = () => {
    if (!reviewList || !Array.isArray(reviewList)) return []

    reviewList.forEach(release => {
      const app = release.data ? JSON.parse(release.data) : null
      release.applicationData = app
    })

    return reviewList.filter(i => {
      if (
        i.applicationData?.name?.toLowerCase().includes(filterText?.toLowerCase()) ||
        i.applicationData?.applicationCategory?.name?.toLowerCase().includes(filterText?.toLowerCase())
      ) {
        return true
      }
      return false
    })
  }

  const renderInnerComponent = () => {
    if (fetchingReviewList) {
      return <LoadingBlock message="Loading..." />
    }
    if (errorFetchingReviewList || !Array.isArray(reviewList)) {
      return <ReviewListErrorState />
    }
    if (reviewList?.length === 0) {
      return <ReviewListEmptyState />
    }
    return (
      <Fragment>
        <SectionHeader
          title="Pending Reviews"
        />
        <SearchField
          placeholder="Which review do you want to see?"
          value={filterText}
          onChange={(value) => setFilterText(value)}
        />
        <Table
          headers={headers}
          rows={generateTableRows()}
          onRowClick={(row) => { history.push(`/admin/pending-reviews/${row?.orignal?.id}`) }}
        />
      </Fragment>
    )
  }

  return (
    <div className="pending-reviews-container">
      {renderInnerComponent()}
    </div>
  )
}

export default PendingReviews



